import React, { useEffect, useState } from 'react';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { useOrderStore } from 'src/hooks/order';
import { __remove, __set } from "src/store/axios_indicator";
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import ProPositionWarning from '../Checkout/ProPositionWarning';

const QuoteCheckoutTotal = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { isFrom } = props

    const {
        shippingAddressType: { CountryCode: { US }, StateCode: { CA } },
        currencyType: { USD },
        taxExempt: { NONE, EXEMPT } } = Constants

    const [{ CART_TAX_TARIFF, }, { fetch_cart_tax }, { set_cart_tax }] = useCartStore()
    const [{ place_order_item_list }, { billing_currency_conversion }, { }] = useOrderStore();
    const [{ validate_order_from_server }] = useOrderStore();

    const [prop65Part, setProp65Part] = useState(false);
    const [subTotal, setSubTotal] = useState(0);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState({ monitorJs: false, frameworkReady: false });

    const [taxExemptDetails, setTaxExemptDetails] = useReduxState({ taxExemptFile: '', taxExempt: NONE }, "setTaxExemptDetails");
    const [paymentMethodInfo] = useReduxState({}, 'setPaymentMethodInfo')
    const [quoteList] = useReduxState({}, 'QuoteCartList')
    const [quoteHeaderData] = useReduxState({}, 'setQuoteHeaderData')
    const checkoutDataModel = {
        orderEstimationReq: {
            estimatedShipping: 0,
            estimatedTarrif: 0,
            estimatedTax: EXEMPT,
            itemsSubTotal: 0,
            orderTotal: 0,
            rateOfExchange: 0,
            billingCurrency: paymentMethodInfo?.billingCurrency || USD
        }
    }
    const [checkoutData, setCheckoutData] = useReduxState(checkoutDataModel, 'setCheckoutData')

    useEffect(() => {
        async function containsProp65Yes() {
            if (quoteList && quoteList?.length > 0) {
                const isProp65 = quoteList?.find(f => f.Prop65Flag === true)
                if (isProp65) {
                    setProp65Part(true)
                } else {
                    setProp65Part(false);
                }
            }
        }
        containsProp65Yes()

        setSubTotal(quoteList?.length > 0 && quoteList?.reduce((acc, cur) => {
            acc += Number(cur.subtotal)
            return acc
        }, 0))
    }, [quoteList])

    if (isFrom === "checkout") {
        useEffect(() => {
            if (!quoteHeaderData?.shipToAddress || !validate_order_from_server || (validate_order_from_server?.taxExempt && taxExemptDetails?.taxExempt === EXEMPT)) {
                set_cart_tax({
                    ...CART_TAX_TARIFF,
                    tax: EXEMPT,
                })
                return;
            }
            const params = {
                addressLineOne: quoteHeaderData?.shipToAddress[0]?.address1stLine || '',
                cityName: quoteHeaderData?.shipToAddress[0]?.city || '',
                stateCode: quoteHeaderData?.shipToAddress[0]?.state || '',
                postalCode: quoteHeaderData?.shipToAddress[0]?.zipCode || '',
                countryCode: quoteHeaderData?.shipToAddress[0]?.country || '',
                currency: checkoutData?.orderEstimationReq?.billingCurrency || paymentMethodInfo?.orderEstimationReq?.billingCurrency || USD,
                subTotal: subTotal || 0,
                shipToAddressId: null,
                estimatedShipping: Number(checkoutData?.carrier?.value) || 0,
                taxExempt: taxExemptDetails?.taxExempt || NONE,
                quoteCart: quoteList
            }
            async function fetchHere() {
                await fetch_cart_tax(params);
            }
            fetchHere();
        }, [subTotal, checkoutData?.carrier?.value, taxExemptDetails?.taxExempt, validate_order_from_server?.taxExempt]);

        useEffect(() => {
            async function fetchHere() {
                __set('CART_TOTAL_SUMMARY_CALCULATION')
                const params = {
                    baseCurrency: USD,
                    billingCurrency: paymentMethodInfo?.billingCurrency,
                    orderTotal: subTotal + (Number(CART_TAX_TARIFF.tax) || 0) + (Number(CART_TAX_TARIFF.tariff) || 0) + (Number(checkoutData?.carrier?.value) || 0),
                    estimatedShipping: Number(checkoutData?.carrier?.value) || 0,
                    estimatedTarrif: Number(CART_TAX_TARIFF.tariff) || 0,
                    estimatedTax: Number(CART_TAX_TARIFF.tax) || 0,
                    itemsSubTotal: subTotal,
                }
                const res = await billing_currency_conversion(params);
                if (res) {
                    setCheckoutData({
                        ...checkoutData,
                        orderEstimationReq: {
                            estimatedShipping: res?.estimatedShipping,
                            estimatedTarrif: res?.estimatedTarriff,
                            estimatedTax: res?.estimatedTax,
                            itemsSubTotal: res?.itemsSubtotal,
                            billingCurrency: res?.billingCurrency,
                            orderTotal: Number(res?.orderTotal) || 0,
                            rateOfExchange: res?.exchangeRate
                        }
                    })
                    if (!monitorFunctionCall?.frameworkReady) {
                        System.monitorFrameWorkReady()
                        setMonitorFunctionCall({ ...monitorFunctionCall, frameworkReady: true })
                    }
                }
                __remove('CART_TOTAL_SUMMARY_CALCULATION')
            }
            if (checkoutData?.orderTotal !== 0 && paymentMethodInfo?.billingCurrency != USD && Object.keys(validate_order_from_server || {})?.length > 0) {
                fetchHere();
            } else {
                setCheckoutData({
                    ...checkoutData,
                    orderEstimationReq: {
                        estimatedShipping: Number(checkoutData?.carrier?.value) || 0,
                        billingCurrency: paymentMethodInfo?.billingCurrency,
                        estimatedTarrif: CART_TAX_TARIFF.tariff,
                        estimatedTax: CART_TAX_TARIFF.tax,
                        itemsSubTotal: subTotal,
                        orderTotal: subTotal + (Number(CART_TAX_TARIFF.tax) || 0) + (Number(CART_TAX_TARIFF.tariff) || 0) + (Number(checkoutData?.carrier?.value) || 0),
                        rateOfExchange: 0,
                    }
                });
            }
        }, [paymentMethodInfo?.billingCurrency, CART_TAX_TARIFF])

    } else if (isFrom === "SuccessCheckout") {
        useEffect(() => {
            setCheckoutData({ ...checkoutData, orderEstimationReq: { ...place_order_item_list?.orderEstimation, billingCurrency: place_order_item_list?.orderEstimation?.currencyType } });
            setTaxExemptDetails({ ...taxExemptDetails, taxExempt: place_order_item_list?.orderEstimation?.taxExempt || NONE })
        }, [place_order_item_list])
    }

    useEffect(() => {
        if (!monitorFunctionCall?.monitorJs) {
            System.monitorJSDx()
            setMonitorFunctionCall({ ...monitorFunctionCall, monitorJs: true })
        }
    }, []);

    return (
        <>
            <div className="checkout-total">
                {__check(['CART_TAX_API_CALL', 'CART_TOTAL_SUMMARY_CALCULATION']).status ?
                    __check(['CART_TAX_API_CALL', 'CART_TOTAL_SUMMARY_CALCULATION']).render
                    :
                    <>
                        <div className='p-15'>
                            <div className="bs5 row mb-1">
                                <div className="col-12">
                                    <div className="bs5 row m-0">
                                        <div className="col-6 px-0">
                                            <span
                                                className="cart-item-count">({System.getCurrentCartCount() || place_order_item_list?.items?.length || 0}) </span>
                                            Items Subtotal:
                                        </div>
                                        <div className="col-6 text-end font_bold_currency ps-1 pe-0">
                                            <span className="font_bold_currency">
                                                {System.getFormatNumber({
                                                    amount: Number(checkoutData?.orderEstimationReq?.itemsSubTotal || 0) || 0,
                                                    maximumFractionDigits: 2,
                                                    isDisplaySymbol: false,
                                                    currency: checkoutData?.orderEstimationReq?.billingCurrency
                                                }) || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bs5 row mb-1 tariff">
                                <div className="col-6">Estimated Tariff:</div>
                                <div className="col-6 text-end">
                                    <b>{Number(checkoutData?.orderEstimationReq?.estimatedTarrif) === 0 ? "---" : System.getFormatNumber({
                                        amount: Number(checkoutData?.orderEstimationReq?.estimatedTarrif) || 0,
                                        isDisplaySymbol: false,
                                        currency: checkoutData?.orderEstimationReq?.billingCurrency
                                    }) || 0}</b>
                                </div>
                            </div>
                            {validate_order_from_server?.message?.countryTariff && <div className="bs5 row mt-2 mb-2">
                                <div className="col-8 ms-2"><i>– the estimated tariff recovery fee is an estimate and will be charged at the time of shipment.</i></div>
                                <div className="col-2 text-end"></div>
                            </div>}
                            <div className="bs5 row mb-1">
                                <div className="col-8"><span className='me-1'>Estimated Shipping:</span>
                                    {/* <img src={infoCircle} alt='Estimated Shipping' /> */}
                                </div>
                                <div className="col-4 text-end"><b>{System.getFormatNumber({
                                    amount: Number(checkoutData?.orderEstimationReq?.estimatedShipping) || 0,
                                    isDisplaySymbol: false,
                                    currency: checkoutData?.orderEstimationReq?.billingCurrency
                                }) || 0}</b></div>
                            </div>
                            <div className="bs5 row mb-1">
                                <div className="col-6">Estimated Tax:</div>
                                <div className="col-6 text-end est-tax">
                                    <b>{((validate_order_from_server?.taxExempt || isFrom === "SuccessCheckout") && taxExemptDetails?.taxExempt === EXEMPT) ? "EXEMPT" : System.getFormatNumber({
                                        amount: Number(checkoutData?.orderEstimationReq?.estimatedTax) || 0,
                                        isDisplaySymbol: false,
                                        currency: checkoutData?.orderEstimationReq?.billingCurrency
                                    }) || 0}</b>
                                </div>
                            </div>


                        </div>
                        <div className="bs5 row total-row m-0 ">
                            <div className="bs5 row m-0 font_bold_currency">
                                <div className="col-4 px-0">
                                    <span><b>Order Total:</b></span>
                                </div>
                                <div className="col-8 text-end est-tax ps-1 pe-0">
                                    <>
                                        <span
                                            className="subtotal-currency font-normal">{checkoutData?.orderEstimationReq?.billingCurrency} </span>
                                        <span
                                            className="font_bold_currency">{System.getFormatNumber({
                                                amount: Number(checkoutData?.orderEstimationReq?.orderTotal) || 0,
                                                maximumFractionDigits: 2,
                                                isDisplaySymbol: false,
                                                currency: checkoutData?.orderEstimationReq?.billingCurrency
                                            }) || 0}</span>
                                    </>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            {((checkoutData?.shipToAddress?.country === US && checkoutData?.shipToAddress?.state === CA) || prop65Part) &&
                <ProPositionWarning />}
        </>
    );
}

export default QuoteCheckoutTotal;